import AppSettings from "@/appsettings";
import {
  deleteCookie as deleteSharedCookie,
  getCookie as getSharedCookie,
  setCookie as setSharedCookie,
} from "../auth/cookies";

export const getCookie = (cookieName) => {
  return getSharedCookie(cookieName) || "";
};

export const setCookie = (name, value) => {
  setSharedCookie(name, value, {
    domain: AppSettings.cookieDomain,
  });
};

export const deleteCookie = (name) => {
  deleteSharedCookie(name, { domain: AppSettings.cookieDomain });
};

export const goToURL = (url) => {
  globalThis.location.href = url;
};

export const isEmail = (string) => {
  if (!/^[^\s@]+@[^\s@]+$/.test(string)) {
    return false;
  }
  // Domain needs a dot with at least one character on each side.
  const domain = string.slice(string.indexOf("@") + 1);
  return domain.slice(1, -1).includes(".");
};

export const handleKeyDown = ({
  event,
  key = "Enter",
  callback = () => {},
}) => {
  if (event.key === key) callback();
};

export const formatMFAOTP = (choices = []) => {
  return choices?.map((choice) => {
    const isEmailChoice = choice.includes("Email to ");
    const isPhoneChoice = choice.includes("Text to ");

    const formattedValue = choice
      .replace("Text to ", "")
      .replace("Email to ", "");

    return {
      value: formattedValue,
      type: isEmailChoice ? "email" : isPhoneChoice ? "phone" : "unknown",
    };
  });
};
